import PermisosUsuarioExb, { PantallaExb } from '@/entities/exbecarios/permisos/permisos-exb.factory';
import { Authority } from '@/shared/security/authority';
import { ChildProcess } from 'child_process';
import path from 'path';
import { component } from 'vue/types/umd';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore
const Solicitud = () => import('@/entities/solicitud/recepcion/solicitud.vue');
// prettier-ignore
const SolicitudUpdate = () => import('@/entities/solicitud/recepcion/solicitud-update.vue');

// prettier-ignore
const SolicitudAdministrar = () => import('@/entities/solicitud/administracion/solicitud.vue');
// prettier-ignore
const SolicitudAsignarRevisor = () => import('@/entities/solicitud/administracion/solicitud-asignar-revisor.vue');

// prettier-ignore
const Solucion = () => import('@/entities/solucion/solucion.vue');
// prettier-ignore
const SolucionUpdate = () => import('@/entities/solucion/solucion-update.vue');
// prettier-ignore
const Convocatoria = () => import('@/entities/convocatoria/convocatoria.vue');
// prettier-ignore
const Revision = () => import('@/entities/revision/revision.vue');
// prettier-ignore
const RevisionUpdate = () => import('@/entities/revision/revision-update.vue');
// prettier-ignore
const Form = () => import('@/entities/form/form.vue');
// prettier-ignore
const FormUpdate = () => import('@/entities/form/form-update.vue');
// prettier-ignore
const FormDetails = () => import('@/entities/form/form-details.vue');
// prettier-ignore
const Pago = () => import('@/entities/administracion/pago/pago.vue');

const Insaculacion = () => import('@/entities/evaluacion/insaculacion/insaculacion.vue');

const AdminComisionesList = () => import('@/entities/evaluacion/insaculacion/adminComisionesList.vue');

const AsignacionSolicitudes = () => import('@/entities/evaluacion/asignacion/asignacionSolicitudes.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here
// prettier-ignore

const bandejaSolicitudes = () => import('@/entities/evaluacion/bandeja-solicitudes/bandeja-solicitudes.vue');

const bandejaPlenariaSolicitud = () => import('@/entities/evaluacion/bandeja-plenaria-solicitud/bandeja-plenaria-solicitud.vue');

const bandejaAdministracion = () => import('@/entities/evaluacion/bandeja-administracion/bandeja-administracion.vue');

const DictamenPlenaria = () => import('@/entities/evaluacion/dictamen-plenaria/dictamen-plenaria.vue');

const ConsejoGeneral = () => import('@/entities/evaluacion/dictamen-plenaria/consejo-general.vue');

const RegitroMovimientoOperador = () => import('@/components/movimientos/registro-movimiento-operador/registro-movimiento-operador.vue');

const DocumentosAcreditaciones = () => import('@/entities/acreditaciones/documentos-acreditaciones.vue');

const Reportes = () => import('@/entities/reportes/reportes.vue');

const CancelarSolicitudes = () => import('@/entities/solicitud/cancelacion/solicitud-cancelar.vue');

const BandejaFormalizacion = () => import('@/entities/evaluacion/formalizacion/oficios-reconocimientos/bandeja-formalizacion.vue');

const AsignarFirmanteFormalizacion = () =>
  import('@/entities/evaluacion/formalizacion/asignar-firmante-formalizacion/asignar-firmante-formalizacion.vue');

const BandejaEvaluador = () => import('@/entities/becas/evaluacion-extranjeras/bandeja-evaluador/bandeja-evaluador.vue');

const Sicob = () => import('@/entities/sicob/sicob.vue');

const AdministracionVigencias = () => import('@/entities/administracion/vigencias/administracion-vigencias.vue');
const AdminDictamen = () => import('@/entities/evaluacion/dictamen-plenaria/admin-dictamen.vue');
const RegenerarDocumentosFormalizacion = () =>
  import('@/entities/evaluacion/formalizacion/regeneracion-documentos-formalizacion/regeneracion-documentos-formalizacion.vue');
const AdminAdeudosAll = () => import('@/entities/movimientos/admin-adeudos/admin-adeudos-all.vue');

const RegenerarDocumentosBecasNacionales = () =>
  import('@/entities/seguimiento/formalizar-becas/regenerar-documentos-becas/regenerar-documentos-becas.vue');

//Seguimiento administrativo
const ConsultaSolicitudes = () => import('@/entities/consulta-solicitudes/consulta-solicitudes.vue');
const FormalizarBecas = () => import('@/entities/seguimiento/formalizar-becas/formalizar-becas.vue');
const FirmaIndividualBecas = () => import('@/entities/seguimiento/formalizar-becas/firma-individual.vue');
const ConsultaBecas = () => import('@/entities/seguimiento/consulta-becas/consulta-becas.vue');
const DetalleBeca = () => import('@/entities/seguimiento/detalle-beca/detalle-beca.vue');
const LiberacionPagos = () => import('@/entities/seguimiento/liberacion-pagos/liberacion-pagos.vue');
const LiberacionBecas = () => import('@/entities/seguimiento/liberacion-beca/liberacion-beca.vue');
const LiberacionBecasApoyos = () => import('@/entities/seguimiento/liberacion-beca-apoyos/liberacion-beca-apoyos.vue');
const SeguimientoBecasNacionales = () => import('@/entities/seguimiento/seguimiento-menu.vue');
const ConsultarMovimiento = () => import('@/entities/seguimiento/movimiento-beca/movimiento-beca-formulario.vue');
const AgregarMovimiento = () => import('@/entities/seguimiento/movimiento-beca/movimiento-beca-formulario.vue');
const ConsultaMovimientosBecas = () => import('@/entities/seguimiento/consulta-movimientos/consulta-movimientos.vue');
const ConsultaUmas = () => import('@/entities/seguimiento/financiero/administracion-umas/consulta-umas/consulta-umas.vue');
const AsignacionOperador = () => import('@/entities/seguimiento/asignacion-operador/asignacion-operador.vue');

//Seguimiento financiero
const ConsultaNominas = () => import('@/entities/seguimiento/consulta-nominas/consulta-nominas.vue');
const Configuracion = () => import('@/entities/seguimiento/financiero/configuracion/configuracion.vue');
const Prenomina = () => import('@/entities/seguimiento/financiero/prenomina/prenomina.vue');
const Dispersion = () => import('@/entities/seguimiento/financiero/dispersion/dispersion.vue');
const Conciliacion = () => import('@/entities/seguimiento/financiero/conciliacion/conciliacion.vue');
const Cierre = () => import('@/entities/seguimiento/financiero/cierre/cierre.vue');
const PeriodosEvaluacionBecas = () => import('@/entities/seguimiento/periodo-evaluacion/periodos-evaluacion.vue');
const DetalleMovimientoAcademico = () => import('@/entities/seguimiento/academico/movimiento-academico-formulario.vue');
const ReportesBecasNacionales = () => import('@/entities/seguimiento/reportes/reportes-bn.vue');
const BuscadorSolicitantesBna = () => import('@/entities/seguimiento/buscadores/buscador-solicitantes-bna/buscador-solicitantes-bna.vue');
const MovimientosPagoPeriodico = () => import('@/entities/seguimiento/financiero/movimiento-periodico/consulta-movimientos-periodico.vue');

//SNP
const SNPMenu = () => import('@/entities/snp/snp-menu.vue');
const Programas = () => import('@/entities/snp/administracion/programas/programas.vue');
const ReportesSnp = () => import('@/entities/snp/administracion/reportes/reportes-snp.vue');
const CoordinadoresInstitucionalesSnp = () =>
  import('@/entities/snp/administracion/coordinadores-institucionales/coordinadores-institucionales.vue');
const AdminCuposProgramas = () => import('@/entities/snp/administracion/cupo-programa.vue');
const EvaluacionSnp = () => import('@/entities/snp/evaluacion/evaluacion-snp.vue');
const EvaluadorSnp = () => import('@/entities/snp/evaluador/evaluador-snp.vue');
const AnalisisInconsistencias = () => import('@/entities/snp/inconsistencias/analisis-inconsistencias/analisis-inconsistencias.vue');

//GPLN
const GPLNMenu = () => import('@/entities/gpln/gpln-menu.vue');
const ReportesGpln = () => import('@/entities/gpln/reportes/reportes-gpln.vue');
const ProgramasGpln = () => import('@/entities/gpln/programas/programas.vue');

//Seguimiento becas extranjeras
const BecasAlExtranjero = () => import('@/entities/seguimiento/extranjeras/seguimiento-menu.vue');
const ConsultaNominasExt = () => import('@/entities/seguimiento/extranjeras/financiero/consulta-nominas.vue');
const ConfiguracionExt = () => import('@/entities/seguimiento/extranjeras/financiero/configuracion/configuracion.vue');
const PrenominaExt = () => import('@/entities/seguimiento/extranjeras/financiero/prenomina/prenomina.vue');
const ReportesBecasExtranjeras = () => import('@/entities/seguimiento/extranjeras/reportes/reportes-bext.vue');
const ConsultaBecasExt = () => import('@/entities/seguimiento/extranjeras/consulta-becas/consulta-becas.vue');
const DetalleBecaExt = () => import('@/entities/seguimiento/extranjeras/detalle-beca/detalle-beca.vue');
const ConsultarMovimientoExtranjeras = () => import('@/entities/seguimiento/extranjeras/movimiento-beca/movimiento-beca-formulario.vue');
const AgregarMovimientoExtranjeras = () => import('@/entities/seguimiento/extranjeras/movimiento-beca/movimiento-beca-formulario.vue');
const DispersionExt = () => import('@/entities/seguimiento/extranjeras/financiero/dispersion/dispersion.vue');
const ConciliacionExt = () => import('@/entities/seguimiento/extranjeras/financiero/conciliacion/conciliacion.vue');
const CierreExt = () => import('@/entities/seguimiento/extranjeras/financiero/cierre/cierre.vue');
const BandejaFormalizacionBecas = () => import('@/entities/seguimiento/extranjeras/formalizacion/bandeja-formalizacion.vue');
const BandejaFormalizacionBecasNacionales = () =>
  import('@/entities/seguimiento/formalizar-becas/bandeja-formalizacion-becas-nacionales/bandeja-formalizacion.vue');
const BandejaFormalizacionGeneralBecas = () =>
  import('@/entities/seguimiento/formalizar-becas/bandeja-formalizacion-general-becas/bandeja-formalizacion-general.vue');
const FirmaIndividualFormalizacionBecas = () =>
  import('@/entities/seguimiento/extranjeras/formalizacion/firma-invidual-formalizacion/firma-individual-formalizacion-becas.vue');
const MovimientosMasivosBecasExt = () => import('@/entities/seguimiento/extranjeras/movimientos-masivos/movimientos-masivos.vue');
const InsaculacionBext = () => import('@/entities/seguimiento/extranjeras/insaculacion/insaculacionBext.vue');
const AdminComisionesBext = () => import('@/entities/seguimiento/extranjeras/insaculacion/adminComisionesBext.vue');
const BandejaAnexosModificatorios = () => import('@/entities/seguimiento/extranjeras/anexos-modificatorios/bandeja-modificatorios.vue');

const AdminAsignacionBext = () => import('@/entities/seguimiento/extranjeras/asignacionBext/asignacionBext.vue');
//Exbecarios
const Exbecarios = () => import('@/entities/exbecarios/exbecarios-menu.vue');
const CartaConclusion = () => import('@/entities/exbecarios/carta-conclusion/carta-conclusion.vue');
const CartaConclusionExt = () => import('@/entities/exbecarios/carta-conclusion/carta-conclusion-ext.vue');

//Conclusion de beca
const ConsultaBecasExbecarios = () => import('@/entities/exbecarios/consulta-becas/consulta-becas.vue');
const ConsultaBecasExbecariosExt = () => import('@/entities/exbecarios/consulta-becas/consulta-becas-ext.vue');

const ConsultaSolicitudesConclusion = () =>
  import('@/entities/exbecarios/consulta-solicitudes-conclusion/consulta-solicitudes-conclusion.vue');
const ConsultaSolicitudesConclusionExt = () =>
  import('@/entities/exbecarios/consulta-solicitudes-conclusion-ext/consulta-solicitudes-conclusion-ext.vue');
const FirmaDocumentos = () => import('@/entities/exbecarios/documentos-firma/documentos-firma.vue');
const ReportesExbComponent = () => import('@/entities/exbecarios/reportes/reportes-exb.vue');
const CartaConclusionApoyosNacionales = () => import('@/entities/exbecarios/carta-conclusion/carta-conclusion-apoyos-nacionales.vue');

//VerificaciónBecarios
const ConsultaVerificacion = () => import('@/entities/seguimiento/verificacion/consulta-verificacion.vue');

const DetalleDocumentos = () => import('@/entities/seguimiento/extranjeras/detalle-beca/detalle-documentos.vue');

const AdminMasterSNII = () => import('@/entities/movimientos/admin-master-snii/adminMasterSnii.vue');

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'solicitud/:solucionId/list',
      name: 'SolicitudList',
      component: Solicitud,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER] },
    },
    {
      path: 'solicitud',
      name: 'Solicitud',
      component: Solicitud,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER] },
    },
    {
      path: 'solicitud/new',
      name: 'SolicitudCreate',
      component: SolicitudUpdate,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER] },
    },
    {
      path: 'solicitud/:solicitudId/edit',
      name: 'SolicitudEdit',
      component: SolicitudUpdate,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER] },
    },
    {
      path: 'solicitud/:solucionId/edit',
      name: 'SolicitudCreateFromSolucion',
      component: SolicitudUpdate,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER] },
    },
    {
      path: 'solicitud/:solicitudId/view',
      name: 'SolicitudView',
      component: SolicitudUpdate,
      meta: { authorities: [Authority.EXTERNAL_USER, Authority.USER], readOnly: true },
    },
    {
      path: 'solicitud/administracion',
      name: 'SolicitudAdministrar',
      component: SolicitudAdministrar,
      meta: { authorities: [Authority.OPERADOR, Authority.SOPORTE, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: 'solicitud/:solicitudId/administracion/asignar-revisor/edit',
      name: 'SolicitudAsignarRevisor',
      component: SolicitudAsignarRevisor,
      meta: { authorities: [Authority.OPERADOR, Authority.SOPORTE] },
    },
    {
      path: 'solucion',
      name: 'Solucion',
      component: Solucion,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: 'solucion/new',
      name: 'SolucionCreate',
      component: SolucionUpdate,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: 'solucion/:solucionId/edit',
      name: 'SolucionEdit',
      component: SolucionUpdate,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: 'convocatorias',
      name: 'Convocatoria',
      component: Convocatoria,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'revision',
      name: 'Revision',
      component: Revision,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'revision/new',
      name: 'RevisionCreate',
      component: RevisionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'revision/:solicitudId/:revisionId/:evaluacionId/edit',
      name: 'RevisionEdit',
      component: RevisionUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'form',
      name: 'Form',
      component: Form,
      meta: { authorities: [Authority.MODELADOR] },
    },
    {
      path: 'form/new',
      name: 'FormCreate',
      component: FormUpdate,
      meta: { authorities: [Authority.MODELADOR] },
    },
    {
      path: 'form/:formId/edit',
      name: 'FormEdit',
      component: FormUpdate,
      meta: { authorities: [Authority.MODELADOR] },
    },
    {
      path: 'form/:formId/view',
      name: 'FormView',
      component: FormDetails,
      meta: { authorities: [Authority.MODELADOR] },
    },
    {
      path: 'administracion/pago',
      name: 'Pago',
      component: Pago,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: 'bandejaSolicitudes',
      name: 'bandeja-solicitudes',
      component: bandejaSolicitudes,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'evaluacion/insaculacion',
      name: 'Insaculacion',
      component: Insaculacion,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'evaluacion/adminComisionesList',
      name: 'AdminComisionesList',
      component: AdminComisionesList,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'asignacion/asignacionSolicitudes',
      name: 'AsignacionSolicitudes',
      component: AsignacionSolicitudes,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'bandejaPlenariaSolicitud',
      name: 'BandejaPlenariaSolicitud',
      component: bandejaPlenariaSolicitud,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bandeja/administracion',
      name: 'BandejaAdministracion',
      component: bandejaAdministracion,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'evaluacion/dictamenPlenaria',
      name: 'DictamenPlenaria',
      component: DictamenPlenaria,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/ConsejoGeneral',
      name: 'ConsejoGeneral',
      component: ConsejoGeneral,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/regitroMovimientoOperador',
      name: 'RegitroMovimientoOperador',
      component: RegitroMovimientoOperador,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'documentos/Acreditaciones',
      name: 'DocumentosAcreditaciones',
      component: DocumentosAcreditaciones,
      meta: { authorities: [Authority.SOPORTE] },
    },
    {
      path: '/reportes',
      name: 'Reportes',
      component: Reportes,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR] },
    },
    {
      path: '/consultaSolicitudes',
      name: 'ConsultaSolicitudes',
      component: ConsultaSolicitudes,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/consultaBecas/:area',
      name: 'ConsultaBecas',
      component: ConsultaBecas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/formalizarBecas/:area',
      name: 'FormalizarBecas',
      component: FormalizarBecas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/firmaIndividual/:area/:idSolicitud',
      name: 'FirmaIndividualBecas',
      component: FirmaIndividualBecas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/liberacionPagos',
      name: 'LiberacionPagos',
      component: LiberacionPagos,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/liberacionBecas',
      name: 'LiberacionBecas',
      component: LiberacionBecas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/liberacionBecasApoyos',
      name: 'LiberacionBecasApoyos',
      component: LiberacionBecasApoyos,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/detalleBeca/:becaId',
      name: 'DetalleBeca',
      component: DetalleBeca,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/seguimientoBecasNacionales',
      name: 'SeguimientoBecasNacionales',
      component: SeguimientoBecasNacionales,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/reportesBecasNacionales',
      name: 'ReportesBecasNacionales',
      component: ReportesBecasNacionales,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/buscador-solicitantes-bna',
      name: 'buscadorSolicitantesBna',
      component: BuscadorSolicitantesBna,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/movimientoBeca/:movimientoBecaId',
      name: 'MovimientoBeca',
      component: ConsultarMovimiento,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'cancelar/solicitudes',
      name: 'CancelarSolicitudes',
      component: CancelarSolicitudes,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/movimientoBeca/:becaId',
      name: 'AgregarMovimientoBeca',
      component: AgregarMovimiento,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/consultaMovimientosBecas',
      name: 'ConsultaMovimientosBecas',
      component: ConsultaMovimientosBecas,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/movimientoBeca/:movimientoBecaId/:permisoRevision',
      name: 'ConsultarMovimientoBeca',
      component: ConsultarMovimiento,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/bandejaFormalizacion',
      name: 'BandejaFormalizacion',
      component: BandejaFormalizacion,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/asignar-firmante-formalizacion',
      name: 'AsignarFirmanteFormalizacion',
      component: AsignarFirmanteFormalizacion,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/becas-extranjeras/evaluacion',
      name: 'BandejaEvaluador',
      component: BandejaEvaluador,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'exbecarios/sicob',
      name: 'Sicob',
      component: Sicob,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/consultaNominas',
      name: 'ConsultaNominas',
      component: ConsultaNominas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/configuracion/:idNomina',
      name: 'Configuracion',
      component: Configuracion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/prenomina/:idNomina',
      name: 'Prenomina',
      component: Prenomina,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/dispersion/:idNomina',
      name: 'Dispersion',
      component: Dispersion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/conciliacion/:idNomina',
      name: 'Conciliacion',
      component: Conciliacion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/cierre/:idNomina',
      name: 'Cierre',
      component: Cierre,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/movimientosPeriodicos',
      name: 'MovimientosPeriodicos',
      component: MovimientosPagoPeriodico,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/periodosEvaluacionBecas',
      name: 'PeriodosEvaluacionBecas',
      component: PeriodosEvaluacionBecas,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/snp',
      component: SNPMenu,
      name: 'SNPMenu',
      children: [
        {
          path: 'programas',
          name: 'Programas',
          component: Programas,
        },
        {
          path: 'reportes-snp',
          name: 'reportes-snp',
          component: ReportesSnp,
        },
        {
          path: 'adminCuposProgramas',
          name: 'adminCuposProgramas',
          component: AdminCuposProgramas,
        },
        {
          path: 'coordinadores-institucionales',
          name: 'coordinadores-institucionales',
          component: CoordinadoresInstitucionalesSnp,
        },
        {
          path: 'evaluacion-snp',
          name: 'evaluacion-snp',
          component: EvaluacionSnp,
        },
        {
          path: 'evaluador-snp',
          name: 'evaluador-snp',
          component: EvaluadorSnp,
        },
        {
          path: 'analisis-inconsistencias',
          name: 'analisis-inconsistencias',
          component: AnalisisInconsistencias,
        },
      ],
      meta: { authorities: [Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/gpln',
      component: GPLNMenu,
      name: 'GPLNMenu',
      children: [
        {
          path: 'reportes-gpln',
          name: 'reportes-gpln',
          component: ReportesGpln,
        },
        {
          path: 'programas',
          name: 'programas',
          component: ProgramasGpln,
        },
      ],
      meta: { authorities: [Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/movimientoAcademico/:idBeca/:idPeriodo',
      name: 'DetalleMovimientoAcademico',
      component: DetalleMovimientoAcademico,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/administracion/vigencias',
      name: 'administracionVigencias',
      component: AdministracionVigencias,
    },
    {
      path: '/becasAlExtranjero',
      name: 'BecasAlExtranjero',
      component: BecasAlExtranjero,
      children: [
        {
          path: 'reportes-bext',
          name: 'reportes-bext',
          component: ReportesBecasExtranjeras,
        },
      ],
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/consultaNominasExt',
      name: 'ConsultaNominasExt',
      component: ConsultaNominasExt,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/becas-extranjero/consulta/:area',
      name: 'ConsultaBecasExt',
      component: ConsultaBecasExt,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/movimientos-masivos',
      name: 'MovimientosMasivosBecasExt',
      component: MovimientosMasivosBecasExt,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/becas-extranjero/detalle/:becaId',
      name: 'DetalleBecasExt',
      component: DetalleBecaExt,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/becas-extranjero/movimientoBeca/:becaId',
      name: 'AgregarMovimientoBecaExtranjeras',
      component: AgregarMovimientoExtranjeras,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/becas-extranjero/:movimientoBecaId',
      name: 'MovimientoBecaExtranjeras',
      component: ConsultarMovimientoExtranjeras,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/becas-extranjero/:movimientoBecaId/:permisoRevision',
      name: 'ConsultarMovimientoBecaExtranjeras',
      component: ConsultarMovimientoExtranjeras,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/bandejaFormalizacionBecas',
      name: 'BandejaFormalizacionBecas',
      component: BandejaFormalizacionBecas,
      meta: { authorities: [Authority.USER, Authority.OPERADOR] },
    },
    {
      path: '/bandejaFormalizacionBecasNacionales',
      name: 'BandejaFormalizacionBecasNacionales',
      component: BandejaFormalizacionBecasNacionales,
      meta: { authorities: [Authority.USER, Authority.OPERADOR] },
    },
    {
      path: '/firmaIndividualBecas',
      name: 'FirmaIndividualFormalizacionBecas',
      component: FirmaIndividualFormalizacionBecas,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/bandejaAnexosModificatorios',
      name: 'bandejaAnexosModificatorios',
      component: BandejaAnexosModificatorios,
      meta: { authorities: [Authority.USER, Authority.OPERADOR] },
    },
    {
      path: '/configuracionExt/:idNomina',
      name: 'ConfiguracionExt',
      component: ConfiguracionExt,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/prenominaExt/:idNomina',
      name: 'PrenominaExt',
      component: PrenominaExt,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/dispersionExt/:idNomina',
      name: 'DispersionExt',
      component: DispersionExt,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/conciliacionExt/:idNomina',
      name: 'ConciliacionExt',
      component: ConciliacionExt,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/cierreExt/:idNomina',
      name: 'CierreExt',
      component: CierreExt,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/cartaConclusion/:becaId',
      name: 'cartaConclusion',
      component: CartaConclusion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/cartaConclusionExt/:becaId',
      name: 'cartaConclusionExt',
      component: CartaConclusionExt,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios',
      name: 'Exbecarios',
      component: Exbecarios,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/consultaBecas',
      name: 'ConsultaBecasExbecarios',
      component: ConsultaBecasExbecarios,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/consultaBecasExt',
      name: 'ConsultaBecasExbecariosExt',
      component: ConsultaBecasExbecariosExt,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/solicitudesConclusion',
      name: 'ConsultaSolicitudesConclusion',
      component: ConsultaSolicitudesConclusion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/exbecarios/solicitudesConclusionExt',
      name: 'ConsultaSolicitudesConclusionExt',
      component: ConsultaSolicitudesConclusionExt,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/consultaUmas',
      name: 'ConsultaUmas',
      component: ConsultaUmas,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/asignacionOperador',
      name: 'AsignacionOperador',
      component: AsignacionOperador,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/consultaVerificacion',
      name: 'ConsultaVerificacion',
      component: ConsultaVerificacion,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: 'evaluacion/adminDictamen',
      name: 'AdminDictamen',
      component: AdminDictamen,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: 'exbecarios/firmaDocumentos',
      name: 'FirmaDocumentos',
      component: FirmaDocumentos,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: 'exbecarios/reportes',
      name: 'ReportesExb',
      component: ReportesExbComponent,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/exbecarios/cartaConclusionApoyosNacionales/:becaId',
      name: 'cartaConclusionApoyosNacionales',
      component: CartaConclusionApoyosNacionales,
      meta: { authorities: [Authority.OPERADOR_PROGRAMA, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/bandejaFormalizacionGeneralBecas',
      name: 'BandejaFormalizacionGeneralBecas',
      component: BandejaFormalizacionGeneralBecas,
      meta: { authorities: [Authority.USER, Authority.OPERADOR] },
    },
    {
      path: '/regenerarDocumentosFormalizacion',
      name: 'RegenerarDocumentosFormalizacion',
      component: RegenerarDocumentosFormalizacion,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: '/detalleDocumentos/:idBeca/:idPeriodo',
      name: 'DetalleDocumentos',
      component: DetalleDocumentos,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/adminAdeudosAll/:cvu/:solucionId',
      name: 'AdminAdeudosAll',
      component: AdminAdeudosAll,
      meta: { authorities: [Authority.OPERADOR] },
    },
    {
      path: '/regenerarDocumentosBecasNacionales',
      name: 'RegenerarDocumentosBecasNacionales',
      component: RegenerarDocumentosBecasNacionales,
      meta: { authorities: [Authority.INNOVADOR] },
    },
    {
      path: '/insaculacionBext',
      name: 'insaculacionBext',
      component: InsaculacionBext,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/adminComisionesBext',
      name: 'adminComisionesBext',
      component: AdminComisionesBext,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/adminAsignacionBext',
      name: 'adminAsignacionBext',
      component: AdminAsignacionBext,
      meta: { authorities: [Authority.OPERADOR, Authority.AUDITOR, Authority.USER] },
    },
    {
      path: '/adminMasterSnii',
      name: 'AdminMasterSnii',
      component: AdminMasterSNII,
      meta: { authorities: [Authority.ADMIN, Authority.OPERADOR_PROGRAMA, Authority.USER] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
